
import axiosMiddleware from './axiosMiddleware'
import env from '../config/env'

const applyForPrivilege = async (params) => axiosMiddleware(env.BACKEND_END_POINT).post('/Apply', params)

export default applyForPrivilege
